//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class PendingOrganization extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'PendingOrganization';
  }
}
PendingOrganization.initClass();

export { PendingOrganization };
